function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m285 0h-240c-24.8125 0-45 20.1875-45 45v422c0 24.8125 20.1875 45 45 45h240c24.8125 0 45-20.1875 45-45v-422c0-24.8125-20.1875-45-45-45zm-240 30h240c8.269531 0 15 6.730469 15 15v286h-270v-286c0-8.269531 6.730469-15 15-15zm240 452h-240c-8.269531 0-15-6.730469-15-15v-106h270v106c0 8.269531-6.730469 15-15 15zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m270 120h-210v181h210zm-30 151h-150v-121h150zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m150 60h30v30h-30zm0 0"
});

function Svg311(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-91 0 512 512",
    width: "512pt",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg311);
export default __webpack_public_path__ + "static/media/3_11.2a7abbe0.svg";
export { ForwardRef as ReactComponent };